<template>
  <div id="app" :style="`background: ${isPlatform ? '#071B27' : '#fff'};`">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    isPlatform() {
      if (this.$route.name) {
        return this.$route.name.includes('Platform');
      }
      return false;
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      })
    }
  }
}
</script>

<style lang="scss">
// @import '@/style/transition.scss';
@import '@/style/color.scss';
@import '@/style/element.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $font-color;
  height: 100vh;
  overflow: auto;
  font-size: 14px;
}
html {
  font-size: 19.2px;
}
@media only screen and (max-width: 1920px) {
   #app{
      overflow: hidden;
   }
}

@media only screen and (min-width: 2049px) and (max-width: 2560px) {
   html{
      font-size: 25.6px;
   }
}
@media only screen and (min-width: 1921px) and (max-width: 2048px) {
   html{
      font-size: 20.48px;
   }
}
@media only screen and (min-width: 1857px) and (max-width: 1920px) {
   html{
      font-size: 19.2px;
   }
}
@media only screen and (min-width: 1793px) and (max-width: 1856px) {
   html{
      font-size: 18.56px;
   }
}
@media only screen and (min-width: 1681px) and (max-width: 1792px) {
   html{
      font-size: 17.92px;
   }
}
@media only screen and (min-width: 1661px) and (max-width: 1680px) {
   html{
      font-size: 16.8px;
   }
}
@media only screen and (min-width: 1601px) and (max-width: 1660px) {
   html{
      font-size: 16.6px;
   }
}
@media only screen and (min-width: 1441px) and (max-width: 1600px) {
   html{
      font-size: 16px;
   }
}
@media only screen and (min-width: 1367px) and (max-width: 1440px) {
   html{
      font-size: 14.4px;
   }
}
@media only screen and (min-width: 1361px) and (max-width: 1366px) {
   html{
      font-size: 13.66px;
   }
}
@media only screen and (min-width: 1281px) and (max-width: 1360px) {
   html{
      font-size: 13.6px;
   }
}
@media only screen and (min-width: 1153px) and (max-width: 1280px) {
   html{
      font-size: 12.8px;
   }
}
@media only screen and (min-width: 1025px) and (max-width: 1152px) {
   html{
      font-size: 11.52px;
   }
}
@media only screen and (min-width: 901px) and (max-width: 1024px) {
   html{
      font-size: 10.24px;
   }
}
@media only screen and (min-width: 801px) and (max-width: 900px) {
   html{
      font-size: 9px;
   }
}
@media only screen and (max-width: 800px) {
   html{
      font-size: 8px;
   }
}
body {
  margin: 0;
  padding: 0;
}
.maxheight-dialog {
  .el-dialog__body {
    max-height: 350px;
    overflow: auto;
  }
}
.forbiddenBtn {
  display: none;
}
.el-message-box__btns {
  padding: 5px 15px 0;
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue